import { css } from 'styled-components';
import { spaceMixin } from '@zillow/constellation';

export default (props) =>
  props.theme &&
  props.theme.ns &&
  css`
    text-decoration: none;

    .Link-icon-item {
      display: inline-block;
      margin-right: ${spaceMixin('xs')};
      vertical-align: middle;
    }
  `;
